import * as React from 'react';
import { DateTime } from 'ui';
import { createFormatters, createUTCDate, dateToUTC, parseAsDateUTC } from 'app/infrastructure/data/date';
import { DuplicateRowsFieldProps, IndicatorFactorsPicker } from 'app/area/indicator-factors/types';

export const ValidFrom = (props: DuplicateRowsFieldProps) => {
  const { list: { duplicateRows }, locale, validation, translation } = props;

  const codetableKey = IndicatorFactorsPicker.validFrom;
  const valueItem = duplicateRows?.form && duplicateRows?.form[codetableKey] as Date;

  const onChange = (value: Date) => {
    props.resetValidation(codetableKey);
    props.updateByKey(codetableKey, value);
  };

  return <DateTime
    label={{ text: translation.validFrom }}
    useTime={false}
    value={valueItem}
    readOnly={false}
    componentId={codetableKey}
    className="dateTime"
    parseDate={parseAsDateUTC}
    createDate={createUTCDate}
    cloneDate={dateToUTC}
    locale={locale}
    onChange={onChange}
    captionWrapper={'form'}
    validation={valueItem && validation?.validFrom}
    {...createFormatters(locale)}
  />;
};
